import { get, ref } from "firebase/database";
import { getFirebase } from "../firebase/init.js";

function versionPathKey(version: string): string {
  return version.replace(/\./g, "_");
}

export interface FetchedPack {
  strings?: { en?: Record<string, string>; "zh-TW"?: Record<string, string> };
  version: string;
  snapshot?: string;
}

function decodeStrings(raw: unknown): FetchedPack["strings"] {
  if (!raw || typeof raw !== "object") return undefined;
  const out: NonNullable<FetchedPack["strings"]> = {};
  for (const [locale, val] of Object.entries(raw as Record<string, unknown>)) {
    if (typeof val === "string") {
      out[locale as "en" | "zh-TW"] = JSON.parse(val) as Record<string, string>;
    } else if (val && typeof val === "object") {
      out[locale as "en" | "zh-TW"] = val as Record<string, string>;
    }
  }
  return out;
}

export async function fetchPublicPack(
  kind: "ruleset" | "scene",
  packId: string,
  version: string,
): Promise<FetchedPack | null> {
  const { db } = getFirebase();
  const snap = await get(ref(db, `packs/public/${kind}/${packId}/${versionPathKey(version)}`));
  if (!snap.exists()) return null;
  const raw = snap.val() as Record<string, unknown>;
  return { ...raw, strings: decodeStrings(raw.strings) } as FetchedPack;
}
